// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-Popover{position:absolute;background:#fff;border-radius:1em;width:30vh;padding:10px;z-index:1;box-shadow:0 4px 15px rgba(50,50,93,.1),0 1px 11px rgba(0,0,0,.08);display:none}.info:hover+.info-Popover{display:block}", ""]);
// Exports
module.exports = exports;
